import { db } from "./DBHelper";
import { COLLECTIONS, APP_SETTING_KEYS } from "../const";
import { getDB } from "./IndexDBHelper";

const STORE = COLLECTIONS.APP_SETTINGS.name;

export async function saveSetting(key, value) {
  return db.update(STORE, key, { key, value });
}

export async function getSetting(key) {
  const list = await db.filter(STORE, { key });
  return list[0]?.value ?? null;
}

export async function deleteSetting(key) {
  return db.delete(STORE, key);
}

export async function saveNextBillNumber(nextBillNo) {
  return saveSetting(APP_SETTING_KEYS.NEXT_BILL_NO, Number(nextBillNo));
}

export async function isBillSetupCompleted() {
  const prefix = await getSetting(APP_SETTING_KEYS.BILL_NUMBER_PREFIX);
  const nextNo = await getSetting(APP_SETTING_KEYS.NEXT_BILL_NO);
  return Boolean(prefix && nextNo !== null && nextNo !== undefined && nextNo !== "");
}

export async function clearAllIndexedDB() {
  try {
    const database = await getDB();
    const storeNames = Array.from(database.objectStoreNames).filter((name) => name !== COLLECTIONS.APP_SETTINGS.name);

    if (storeNames.length > 0) {
      const tx = database.transaction(storeNames, "readwrite");
      for (const storeName of storeNames) {
        tx.objectStore(storeName).clear();
      }
      await tx.done;
    }
  } catch (err) {
    console.error("Failed to clear IndexedDB stores:", err);
  }
}

// TODO: why this is being used?
export const getNewBillNumber = async () => {
  const prefix = (await getSetting(APP_SETTING_KEYS.BILL_NUMBER_PREFIX)) ?? "";
  const suffix = Number((await getSetting(APP_SETTING_KEYS.NEXT_BILL_NO)) ?? 1);
  const bill_no = `${prefix}${suffix}`;
  return { bill_no, bare_bill_no: suffix };
};
